<template>
  <div class="col-sm-6 col-12 px-2 mt-sm-0 mt-3">
    <div class="card address-card address-card--featured">
      <div class="address-card__badge tag-badge tag-badge--theme">
        Billing Address
      </div>
      <div class="address-card__body">
        <div class="address-card__name">{{ addressinfo[0].name }}</div>
        <div class="address-card__row">
          {{ addressinfo[0].locationsname }}<br />
          <span v-if="addressinfo[0].address1 != ''">{{ addressinfo[0].address1 }}</span><span v-if="addressinfo[0].address2 != ''"> {{ addressinfo[0].address2 }}</span>
          <br />
          {{ addressinfo[0].city }}, {{ addressinfo[0].state }} {{ addressinfo[0].zip }}
        </div>
        <div class="address-card__row">
          <div class="address-card__row-title">Phone Number</div>
          <div class="address-card__row-content">{{ format_phone_no(addressinfo[0].phone) }}<!-- (919) 278-0008--></div>
        </div>
        <!-- <div class="address-card__row">
          <div class="address-card__row-title">Email Address</div>
          <div class="address-card__row-content">ryan@example.com</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Formatter from '../../../mixins/formatter';
export default {
  mixins: [Formatter],
  props: {
      addressinfo: {
          type: Array,
          required: true
      }
  }
}
</script>